<div class="flex">
  <app-sidebar></app-sidebar>

  <main class="bg-rounded p-8 bg-dark-purple-50 space-y-4 w-full max-h-screen overflow-y-auto" id="main-container">
    <router-outlet></router-outlet>
  </main>

  <app-chat-history [activeChatId]="chatId()" *ngIf="showChatHistory()"></app-chat-history>
</div>
